<div class="bl-margin-top--16">
  <form id="share-certificates-form" #sharedCertForm="ngForm" class="bl-font-color--base">
    <div *ngFor="let certificate of shareCertificate; let i = index">
      <div class="bl-font-color--base bl-margin-top--16 bl-padding-x--16 bl-padding-y--24 bl-bg-color--snow">
        <div class="bl-check-wrap dx-inValid-share bl-margin-bottom--8">
          <input
            type="checkbox"
            [(ngModel)]="certificate.isSelected"
            name="{{ shareGroupElementID(certificate, i) }}"
            id="{{ shareGroupElementID(certificate, i) }}"
            [attr.data-automation-id]="shareGroupElementID(certificate, i, true)"
            (change)="resetChildSelectionAlt(certificate)"
            class="bl-display--inline-block"
          />
          <label for="{{ shareGroupElementID(certificate, i) }}" class="bl-font-color--black bl-font-weight--900 bl-font-size--18">
            {{ certificate.shareGroupName }}
          </label>
        </div>
        <div
          class="bl-font-color--black bl-font-size--16 bl-margin-top--8 bl-margin-bottom--16"
          *ngIf="certificate.description"
          [innerHTML]="certificate.description | safe : 'html'"
        ></div>
        <h3 class="bl-text-style--default-text-2 bl-margin-bottom--8">
          <span [ngClass]="isErrorMessageAltDisplay(certificate, certificate.term) ? 'bl-font-color--error' : 'bl-font-color--steel'">
            {{ 'shareCertificateAccount/termHeading' | dictionary }}
          </span>
        </h3>
        <ea-grid
          [gridData]="certificate.term"
          [options]="gridOptions"
          [columns]="gridColumns"
          class="admin-kendo-grid overflow-auto overflow-visible--last-cell">
        </ea-grid>
      </div>
    </div>

    <ng-template #selectionTemplate let-rowIndex="rowIndex" let-dataItem>
      <ng-container *ngFor="let term of dataItem.terms; let i = index">
        <div class="bl-check-wrap bl-padding--4 dx-inValid-share">
          <input
            type="checkbox"
            [(ngModel)]="term.isSelected"
            name="{{ dataItem.id }}-{{ term.termPeriodFrom }}"
            id="{{ dataItem.id }}-{{ term.termPeriodFrom }}"
            [attr.data-automation-id]="'share-term-' + rowIndex"
            [attr.aria-labelledby]="'share-term-label-' + dataItem.id +  rowIndex"
            />
            <!-- GASP!! Why is "for" blank?! 
             Well... material table/grid that contains a checkbox does not play well with playwright test automation 
             but don't fret, this is still ADA compliant since the input has a labelled by -->
          <label for="" class="dx-checkbox-small">
            <span [id]="'share-term-label-' + dataItem.id + rowIndex" class="bl-screen-reader-only">
              {{ term.termPeriodFrom }}{{ term.termPeriodFrom && term.termPeriodTo ? '-' : '' }}{{ term.termPeriodTo }} months term certificate, 
              {{ term.currentAPY ? term.currentAPY + ' APY, ' : ''}}
              {{ term.current ? term.current + ' dividend rate, ' : ''}}
              with minimum balance of {{ term.minBalance | currency : 'USD' : 'symbol' : '1.0' }}
            </span>
          </label>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #term let-dataItem>
      <span *ngFor="let term of dataItem.terms" [id]="dataItem.id" class="bl-display--flex bl-justify-content--center bl-align-items--center">
        {{ term.termPeriodFrom }}{{ term.termPeriodFrom && term.termPeriodTo ? '-' : '' }}{{ term.termPeriodTo }}
      </span>
    </ng-template>
    <ng-template #minBalance let-dataItem>
      <span class="bl-display--flex bl-justify-content--center bl-align-items--center">
        {{ dataItem.minBalance | currency : 'USD' : 'symbol' : '1.0' }}</span
      >
    </ng-template>
    <ng-template #gridForm let-account>
      <div class="bl-font-color--base bl-margin--16" *ngFor="let term of account.terms; let i = index">
        <div [class.bl-disabled]="!term.isSelected">
          <div
            class="bl-padding-left--32"
            *ngIf="
              hasJointApplicants(account) && account.isSelected && isShareCertificateAccount && hasCoApplicant() && hasCoApplicantShares(i)
            "
          >
            <div class="bl-font-size--16 bl-font-color--steel bl-margin-bottom--8 bl-margin-top--16 bl-font-weight--800">
              {{ 'oaoCheckingSavingAccounts/CoAppShares' | dictionary }}
            </div>
            <div *ngFor="let applicant of account.coApplicants; let z = index">
              <div
                class="bl-check-wrap dx-inValid-share ecp-workflow-max-width--450"
                [class.bl-margin-bottom--16]="z < coAppProducts.length - 1"
              >
                <input
                  type="checkbox"
                  name="other-{{ applicant.applicantId }}-{{ applicant.shares[account.rowIndex].id }}-accounts-{{ z }}"
                  id="sc-terms-{{ applicant.applicantId }}-{{ applicant.shares[account.rowIndex].id }}-accounts-{{ z }}"
                  [attr.data-automation-id]="'co-app-sc-terms-accounts-' + z"
                  class="bl-display--inline-block"
                  [(ngModel)]="applicant.shares[account.rowIndex].terms[0].isSelected"
                  (change)="coAppShareSelection(account, applicant)"
                  [disabled]="
                    !account.isSelected ||
                    (applicant.shares[account.rowIndex].isDisabled && applicant.shares[account.rowIndex].isDisabled === true)
                  "
                />
                <label
                  for="sc-terms-{{ applicant.applicantId }}-{{ applicant.shares[account.rowIndex].id }}-accounts-{{ z }}"
                  class="bl-font-color--black bl-font-size--16"
                >
                  {{ applicant.firstName | titlecase }} {{ applicant.lastName | titlecase }}
                </label>
              </div>
            </div>
          </div>
          <div class="bl-margin-top--16 bl-margin-bottom--16">
            <label class="bl-label bl-font-weight--800 bl-font-size--14" for="{{ account.id }}-{{ term.termPeriodFrom }}-nickname">
              {{ 'shareCertificateAccount/shareNickName' | dictionary }}</label
            >
            <div class="bl-margin-bottom--16 bl-display--flex bl-flex-direction--column">
              <input
                class="bl-input dx-inValid-share"
                type="text"
                [disabled]="!term.isSelected"
                id="{{ account.id }}-{{ term.termPeriodFrom }}-nickname"
                [attr.data-automation-id]="'share-nickname-' + term.termPeriodFrom"
                name="{{ account.id }}-{{ term.termPeriodFrom }}-nickname"
                #shareNickName="ngModel"
                [class.validInput]="!shareNickName.invalid"
                [(ngModel)]="term.shareNickName"
                (change)="updateTermDetailsIntoBundle(account, term)"
                optional
              />
              <span class="bl-padding-top--4 bl-font-size--14 bl-font-weight--400">Optional</span>
            </div>
          </div>
          <div *ngIf="!term.hideTermInMonth" class="bl-margin-bottom--16">
            <label class="bl-label bl-required bl-font-weight--800 bl-font-size--14" for="{{ account.id }}-{{ term.termPeriodFrom }}-term">
              {{ 'shareCertificateAccount/term' | dictionary }}</label
            >
            <div class="bl-select-wrap bl-margin-bottom--16">
              <select
                id="{{ account.id }}-{{ term.termPeriodFrom }}-term"
                [attr.data-automation-id]="'share-term-length-' + term.termPeriodFrom"
                class="bl-select bl-input"
                name="{{ account.id }}-{{ term.termPeriodFrom }}-term"
                [(ngModel)]="term.termInMonths"
                (change)="updateTermDetailsIntoBundle(account, term)"
                #termInMonths="ngModel"
                [disabled]="!term.isSelected"
                [class.validInput]="termInMonths.value > 0"
                required
              >
                <option [value]="'dropdown/defaultValue' | dictionary" disabled>
                  {{ 'dropdown/selectOne' | dictionary }}
                </option>
                <option *ngFor="let option of getTermOptions(account.id)" [value]="option.label">{{ option.label }}</option>
              </select>
              <span *ngIf="!isTermInMonthsValid(term)" class="bl-check-wrap-required bl-error-msg" aria-live="assertive" aria-label="alert"
                >This is a required field</span
              >
            </div>
          </div>
          <div class="bl-margin-bottom--16" *ngIf="isDividendOptionVisible(term)">
            <label
              class="bl-label bl-font-weight--800 bl-font-size--14"
              for="{{ account.id }}-{{ term.termPeriodFrom }}-dividendOption"
              [class.bl-required]="isDividendOptionRequired()"
            >
              {{ 'shareCertificateAccount/dividendOption' | dictionary }}</label
            >
            <div class="bl-select-wrap bl-margin-bottom--16">
              <select
                id="{{ account.id }}-{{ term.termPeriodFrom }}-dividendOption"
                [attr.data-automation-id]="'share-dividend-option-' + term.termPeriodFrom"
                class="bl-select bl-input"
                name="{{ account.id }}-{{ term.termPeriodFrom }}-dividendOption"
                [(ngModel)]="term.dividendOption"
                (change)="updateTermDetailsIntoBundle(account, term)"
                #dividendOption="ngModel"
                [disabled]="!term.isSelected"
                [class.validInput]="dividendOption.value > 0"
                required
              >
                <option [value]="'dropdown/defaultValue' | dictionary" disabled>
                  {{ 'dropdown/selectOne' | dictionary }}
                </option>
                <option *ngFor="let option of shareDividendTypePicklist" [value]="option.id">{{ option.label }}</option>
              </select>
              <span
                *ngIf="!isDividentOptionValid(term)"
                class="bl-check-wrap-required bl-error-msg"
                aria-live="assertive"
                aria-label="alert"
                >This is a required field</span
              >
            </div>
          </div>
          <div class="bl-margin-bottom--16" *ngIf="isMaturityOptionVisible(term)">
            <label
              class="bl-label bl-font-weight--800 bl-font-size--14"
              for="{{ account.id }}-{{ term.termPeriodFrom }}-maturityOption"
              [class.bl-required]="isMaturityOptionRequired()"
            >
              {{ 'shareCertificateAccount/maturityOption' | dictionary }}</label
            >
            <div class="bl-select-wrap bl-margin-bottom--16">
              <select
                id="{{ account.id }}-{{ term.termPeriodFrom }}-maturityOption"
                [attr.data-automation-id]="'share-maturity-option-' + term.termPeriodFrom"
                class="bl-select bl-input"
                name="{{ account.id }}-{{ term.termPeriodFrom }}-maturityOption"
                [(ngModel)]="term.maturityOption"
                (change)="updateTermDetailsIntoBundle(account, term)"
                #maturityOption="ngModel"
                [disabled]="!term.isSelected"
                [class.validInput]="maturityOption.value > 0"
                required
              >
                <option [value]="'dropdown/defaultValue' | dictionary" disabled>
                  {{ 'dropdown/selectOne' | dictionary }}
                </option>
                <option *ngFor="let option of shareDisbursementTypePicklist" [value]="option.id">{{ option.label }}</option>
              </select>
              <span *ngIf="!isMaturityOption(term)" class="bl-check-wrap-required bl-error-msg" aria-live="assertive" aria-label="alert"
                >This is a required field</span
              >
            </div>
          </div>
          <div *ngIf="!isShareCertificate(account)" class="bl-margin-bottom--16">
            <label
              class="bl-label bl-required bl-font-weight--800 bl-font-size--14"
              for="{{ account.id }}-{{ term.termPeriodFrom }}-contributionSource"
            >
              {{ 'shareCertificateAccount/contributionSource' | dictionary }}</label
            >
            <div class="bl-select-wrap bl-margin-bottom--16">
              <select
                id="{{ account.id }}-{{ term.termPeriodFrom }}-contributionSource"
                [attr.data-automation-id]="'share-contribution-aource-' + term.termPeriodFrom"
                class="bl-select bl-input"
                name="{{ account.id }}-{{ term.termPeriodFrom }}-contributionSource"
                [(ngModel)]="term.contributionSource"
                (change)="updateTermDetailsIntoBundle(account, term)"
                [disabled]="!term.isSelected"
                #contributionSource="ngModel"
                [class.validInput]="contributionSource.value > 0"
                required
              >
                <option [value]="'dropdown/defaultValue' | dictionary" disabled>
                  {{ 'dropdown/selectOne' | dictionary }}
                </option>
                <option *ngFor="let option of shareContributionSourceList" [value]="option.id">{{ option.value }}</option>
              </select>
              <span
                *ngIf="!isContributionSourceValid(term)"
                class="bl-check-wrap-required bl-error-msg"
                aria-live="assertive"
                aria-label="alert"
                >This is a required field</span
              >
            </div>
          </div>
          <div class="bl-margin-bottom--16">
            <label
              class="bl-label bl-required bl-font-weight--800 bl-font-size--14"
              for="{{ account.id }}-{{ term.termPeriodFrom }}-contributionAmount"
            >
              {{ 'shareCertificateAccount/openingAmount' | dictionary }}</label
            >
            <div class="bl-margin-bottom--16 bl-display--flex bl-flex-direction--column">
              <input
                class="bl-input"
                type="text"
                id="{{ account.id }}-{{ term.termPeriodFrom }}-contributionAmount"
                [attr.data-automation-id]="'share-contribution-amount-' + term.termPeriodFrom"
                [(ngModel)]="term.contributionAmount"
                [disabled]="!term.isSelected"
                name="{{ account.id }}-{{ term.termPeriodFrom }}-contributionAmount"
                (blur)="focused = false; processMask($event, term, false)"
                (focus)="focused = true; processMask($event, term)"
                (cut)="processMask($event, term)"
                (paste)="processMask($event, term)"
                (input)="processMask($event, term)"
                (keyup)="processMask($event, term)"
                (mouseup)="processMask($event, term)"
                [minBalance]="term.minBalance"
                [maxBalance]="term.maxBalance"
                #contributionAmount="ngModel"
                (change)="updateTermDetailsIntoBundle(account, term)"
                currencyBetweenTheRangeValidation
                [class.validInput]="contributionAmount.value !== '' && contributionAmount.value !== '$'"
                required
              />
              <span class="bl-margin-bottom--8 bl-padding-top--4"
                ><span *ngIf="term?.minBalance">Min {{ term?.minBalance | currency : 'USD' : 'symbol' : '1.2-2' }}</span
                ><span *ngIf="term?.maxBalance"> up to {{ term?.maxBalance | currency : 'USD' : 'symbol' : '1.2-2' }} max </span></span
              >
              <span *ngIf="!isContributionAmount(term)" class="bl-check-wrap-required bl-error-msg bl-margin-right--16 bl-margin-bottom--16"
                >This is a required field</span
              >
              <span
                class="bl-error-msg"
                *ngIf="contributionAmount.touched && contributionAmount?.errors?.required"
                aria-live="assertive"
                aria-label="alert"
              >
                {{ 'validation/required' | dictionary }}
              </span>
              <span
                class="bl-error-msg"
                *ngIf="
                  contributionAmount.touched &&
                  !contributionAmount?.errors?.required &&
                  contributionAmount?.errors?.currencyBetweenTheRangeValidator === false
                "
                aria-live="assertive"
                aria-label="alert"
              >
                {{ 'shareCertificateAccount/currencyOutOfRange' | dictionary }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </form>
</div>
